import React, {FC} from 'react';
import classNames from 'classnames';

import * as styles from './styles.module.scss';

type ToggleProps = {
	open: boolean
	onClick: () => void
}

export const Toggle: FC<ToggleProps> = ({open, onClick}) => {
	return (
		<div className={classNames({
			[styles.toggle]: true,
			[styles.on]: open,
		})} onClick={onClick}>
			<div className={classNames({
				[styles.slide]: true,
			})} />
		</div>
	);
};
